import { createAction } from "@ngrx/store";

export const fetchFavoriteProjects = createAction(
  'Account.FetchFavoriteProjects'
);
